"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ContextMenu_1 = __importDefault(require("./ContextMenu"));

exports.default = ContextMenu_1.default;